import React, { useState, useRef } from 'react';

const OtpInput = ({ length = 4, onOtpSubmit }) => {
    const [otp, setOtp] = useState(new Array(length).fill(""));
    const inputRefs = useRef([]);

    const handleChange = (e, index) => {
        const value = e.target.value;
        if (isNaN(value)) return;

        const newOtp = [...otp];
        // Only take the last character if multiple digits are pasted
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);

        // Combine OTP digits and call the callback
        const combinedOtp = newOtp.join("");
        if (onOtpSubmit) {
            onOtpSubmit(combinedOtp);
        }

        // Move to next input if value is entered
        if (value && index < length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        // Move to previous input on backspace
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    return (
        <div className="otp-input-container d-flex gap-2 justify-content-center">
            {otp.map((value, index) => (
                <input
                    key={index}
                    type="text"
                    ref={(ref) => (inputRefs.current[index] = ref)}
                    value={value}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className="form-control text-center"
                    style={{ width: "40px", height: "40px", borderRadius: '5px', border: '1px solid #d3d3d3' }}
                    maxLength={1}
                />
            ))}
        </div>
    );
};

export default OtpInput;